"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotaoMenuSanduicheFragment = void 0;
var contextos_frontend_1 = require("@aura/contextos-frontend");
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importDefault(require("react"));
var tags_ga_1 = require("../../../../utils/tags-ga");
var botao_menu_sanduiche_styles_1 = require("./botao-menu-sanduiche.styles");
var BotaoMenuSanduicheFragment = function (_a) {
    var onClick = _a.onClick;
    var _b = (0, contextos_frontend_1.useConfig)(), brand = _b.brand, domain = _b.domain;
    return (react_1.default.createElement(botao_menu_sanduiche_styles_1.ItemsStyled, null,
        react_1.default.createElement(tags_ga_1.TagsGa, { category: ['aura', brand, domain], action: ['clique', 'menu'], label: ['clique', 'menu'], eventType: "clique" },
            react_1.default.createElement(botao_menu_sanduiche_styles_1.MenuBtnStyled, { "aria-label": "Abrir menu", "data-testid": "abrir-menu-sanduiche", id: "abrir-menu-sanduiche", onClick: onClick, tabIndex: 0 },
                react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.Menu, size: "md" })))));
};
exports.BotaoMenuSanduicheFragment = BotaoMenuSanduicheFragment;
